import * as d3 from 'd3';
import { Block, Layer, BlockGeometry, EditMode, Position } from '../../types';
import { createProcessBlock } from './ProcessBlock';
import { createDecisionBlock } from './DecisionBlock';
import { createStartEndBlock } from './StartEndBlock';
import { createNoteBlock } from './NoteBlock';
import { getBlockDimensions } from '../../utils/blockUtils';

export function createBlock(
  container: d3.Selection<HTMLDivElement, unknown, null, undefined>,
  block: Block,
  editMode: EditMode,
  onDragEnd: (id: string, position: BlockGeometry) => void,
  onTextUpdate: (id: string, newText: string) => void,
  allBlocks: Block[] = [],
  t: (key: string) => string,
  setBlocks: React.Dispatch<React.SetStateAction<Block[]>>,
  attributesDataEditable: any,
  onLayerUpdate?: (blockId: string, layerId: string, updates: Partial<Layer>) => void,
  onDragMove?: (updates: Array<{ id: string; position: Position }>) => void,
  getSelectedBlockIds?: () => string[],
  onResizeMove?: (id: string, geometry: BlockGeometry) => void
) {
  // Ensure block has dimensions
  const dimensions = getBlockDimensions(block);
  const blockWithDimensions: any = {
    ...block,
    width: block.width || dimensions.width,
    height: block.height || dimensions.height
  };

  switch (block.type) {
    case 'process':
      return createProcessBlock(container, blockWithDimensions, editMode, onDragEnd, onTextUpdate, allBlocks, t, setBlocks, attributesDataEditable, onLayerUpdate, onDragMove, getSelectedBlockIds, onResizeMove);
    case 'decision':
      return createDecisionBlock(container, blockWithDimensions, editMode, onDragEnd, onTextUpdate, allBlocks, t, setBlocks, onDragMove, getSelectedBlockIds, onResizeMove);
    case 'start':
    case 'end':
      return createStartEndBlock(container, blockWithDimensions, editMode, onDragEnd, onTextUpdate, allBlocks, t, setBlocks, attributesDataEditable, onLayerUpdate, onDragMove, getSelectedBlockIds, onResizeMove);
    case 'note':
      return createNoteBlock(container, blockWithDimensions, editMode, onDragEnd, onTextUpdate, allBlocks, t, setBlocks, onDragMove, getSelectedBlockIds, onResizeMove);
    default:
      return null;
  }
}